module.exports = __webpack_public_path__ + "static/media/girl_student.516b5172.jpg";